export default __webpack_public_path__ + "static/media/e-coupon.ed31a080.png";